import { Component, computed, effect, inject, OnInit } from '@angular/core';
import { PaaService } from '../paa.service';
import { TaskHistory } from '@/types';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { PageHeaderComponent } from '../../../components/shared/page-header/page-header.component';
import { DataTableBuilderComponent } from '../../../components/data-table-builder/data-table-builder.component';
import { getPaaTaskHistoryDataTableStructure } from './utils/paa-task-history.data-table-object';
import { DynamicDataTable } from '@/components/data-table-builder/data-table.types';
import { TranslateService } from '@ngx-translate/core';
import { createServerQuery } from '@/components/data-table-builder/server-query';

@Component({
  selector: 'sm-task-history',
  imports: [CommonModule, PageHeaderComponent, DataTableBuilderComponent],
  templateUrl: './task-history.component.html',
  styleUrl: './task-history.component.scss',
})
export class PaaTaskHistoryComponent implements OnInit {
  paaService = inject(PaaService);
  activatedRoute = inject(ActivatedRoute);
  translate = inject(TranslateService);

  breadcrumb = [
    {
      label: 'paa.pages.current_plans',
      routerLink: ['/paa-current-plans'],
    },
    {
      label: 'paa.pages.task_history',
      routerLink: ['/paa-task-history'],
    },
  ];

  processInstanceId = this.activatedRoute.snapshot.params['processInstanceId'];

  serverQuery = createServerQuery({});
  queryParams = computed(() => ({
    page: this.serverQuery.page(),
    pageSize: this.serverQuery.pageSize(),
    sortBy: this.serverQuery.sortBy(),
    sortOrder: this.serverQuery.sortOrder(),
    search: this.serverQuery.search(),
  }));

  loading = true;
  data: TaskHistory[] = [];
  totalRecords = 0;
  datatableObject: DynamicDataTable = getPaaTaskHistoryDataTableStructure({
    translate: (key: string) => this.translate.instant(key),
  });

  constructor() {
    effect(() => {
      this.serverQuery.page();
      this.serverQuery.pageSize();
      this.serverQuery.search();
      this.serverQuery.sortBy();
      this.serverQuery.sortOrder();
      this.loadData();
    });
  }

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.paaService.getPaaTaskHistory(this.processInstanceId).subscribe(history => {
      this.data = history;
      this.loading = false;
    });
  }
}
